<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <div style="padding: 20px;">

          <el-input v-model="text" clearable placeholder="备注"></el-input>

          <div style="margin-top: 20px;">
            <el-upload
                action=""
                :limit="limitCount"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-progress="onProgress"
                :on-success="imgSuccess"
                :on-error="imgError"
                :http-request="uploadHttp"
                list-type="picture-card"
                :on-remove="handleRemove"
                :class="{disabled:uploadDisabled}"
                :file-list="fileList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
              <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
            </el-dialog>
          </div>


        </div>




      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading"  type="primary" @click.native="edit">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Photo',
  components: {},
  props: [],
  data() {
    return {

      loading: false,

      activityOrderCode:'',



      //上传身份证正面相关参数
      limitCount: 3,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

      text:'',

      imgarr:[],


    }
  },
  methods: {

    onProgress(event, file, fileList) {
      console.log(event,file,fileList);
    },
    // 图片上传成功
    imgSuccess(response, file, fileList) {
      console.log(response,file,fileList);
      this.uploadDisabled = fileList.length >= this.limitCount;
    },
    // 图片上传失败
    imgError(err, file, fileList) {
      console.log(err,file,fileList);
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;

      let Pics = this.imgarr;
      Pics.forEach((item, index) => {
        if (file.uid == item.uid) {
          Pics.splice(index, 1);
        }
      })

    },
    //图片更改
    handleChange(file,fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;
    },

    uploadHttp(file) {

      //console.log(file);

      //获取文件信息
      let fileLen = file.file;
      let uid = fileLen.uid

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        //console.log(res.data);
        that.imgarr.push({ uid: uid, url: res.data.data.path });
      })


    },



    init(code){
      this.activityOrderCode = code;
    },

    closeSelf() {
      this.$emit("closePhotoAdd");
    },


    edit(){

      let arr = [];
      for(let i=0;i<this.imgarr.length;i++){
        arr.push({sort:0,imgPath:this.imgarr[i].url});
      }

      if(this.text == '' || arr.length == 0){
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrderRecord/Add',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderCode:this.activityOrderCode,
          remarks:this.text,
          arr:arr,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){

          this.$emit("closePhotoAdd");
          this.$emit("getPhotoList");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
